<template>
  <list :listLogo="module.logo" :listTitle="$t(`${module.identifier}.feed.list.label`)" :loading="fetching" :typesListAvailable="['displayList']" :total="totalFeeds" @change="onChange">
    <button :disabled="creating" v-bind:class="{ 'is-loading': creating }" class="btn btn--info" slot="header-actions" @click="showModalCreateFeed">{{ $t(`${module.identifier}.feed.create.label`) }}</button>
    <create-modal :key="creadeModelRender" v-model="createFeedFlag" :moduleIdentifier="module.identifier" v-on:account="setTargetAccount" v-on:option="createFeed"/>

    <template slot="filters">
      <form-group label="Código">
        <input type="text" v-model="options.code" class="form-input">
      </form-group>

      <form-group label="Sku">
        <input type="text" v-model="options.sku" class="form-input">
      </form-group>

      <form-group label="Status">
        <select v-model="options.status" class="form-select">
          <option :value=null>Todos</option>
          <option v-for="status in statuses" :key="status" :value="status">{{ $t(`${module.identifier}.feed.statuses.${status}.label`) }}</option>
        </select>
      </form-group>

      <form-group label="Tipo">
        <select v-model="options.type" class="form-select">
          <option :value=null>Todos</option>
          <option v-for="type in types" :key="type" :value="type">{{ $t(`${module.identifier}.feed.type.${type}.label`) }}</option>
        </select>
      </form-group>

      <form-group label="Em fila">
        <select v-model="options.queued" class="form-select">
          <option :value=null>Escolha</option>
          <option :value="true">Sim</option>
          <option :value="false">Não</option>
        </select>
      </form-group>

      <form-group label="Data de criação">
        <el-date-picker
          v-model="createdDate"
          type="daterange"
          format="dd/MM/yyyy"
          start-placeholder="Data Inicial"
          end-placeholder="Data Final">
        </el-date-picker>
      </form-group>
    </template>

    <div class="l-col-12@md" v-if="feeds.length" v-for="feed in feeds" :key="feed">
      <feed-card :feed="feed" :moduleIdentifier="module.identifier"/>
    </div>
    <div class="l-col u-textCenter" v-if="!feeds.length">
      <panel>
        Nenhuma tarefa encontrada.
      </panel>
    </div>
  </list>
</template>

<script>
  import api from '@/api'
  import { mapActions, mapGetters } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { merge } from 'lodash'
  import notifier from '@/notifier'
  import List from '@/components/shared/list/Paginator'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import FeedCard from '@/components/marketplace/shared/feed/Card'
  import CreateModal from '@/components/Feed/CreateModal'

  export default {
    data: () => ({
      options: {
        code: null,
        sku: null,
        status: null,
        queued: null,
        type: null,
        createdStart: null,
        createdEnd: null
      },
      createdDate: [],
      statuses: [],
      types: [],
      creadeModelRender: 0,
      createFeedFlag: false,
      creating: false,
      route: null
    }),
    props: {
      moduleType: {
        type: String,
        required: true
      },
      moduleIdentifier: {
        type: String,
        required: true
      }
    },
    updated () {
      this.creadeModelRender = 0
      const route = this.$router.history.current.path

      if (this.route === route) {
        this.creadeModelRender = 0
        return
      }

      this.onChange({})
      this.route = route
      this.creadeModelRender++
    },
    methods: {
      ...mapActions('feed', [
        'fetchFeeds',
        'clearFeed'
      ]),
      onChange (options) {
        if (this.fetching) {
          return false
        }

        merge(this.options, options)

        this.clearFeed()

        this.fetchFeeds({type: this.moduleType, identifier: this.moduleIdentifier, options: this.options})

        api.getFeedStatuses(this.moduleType, this.moduleIdentifier)
          .then(statuses => (this.statuses = statuses))
          .catch(() => (this.statuses = []))

        api.getFeedTypes(this.moduleType, this.moduleIdentifier)
          .then(types => (this.types = types))
          .catch(() => (this.types = []))
      },
      showModalCreateFeed () {
        this.createFeedFlag = true
      },
      setTargetAccount (account) {
        this.account = account
      },
      createFeed () {
        this.creating = true

        if (this.moduleIdentifier === 'amazon') {
          if (this.account === undefined) {
            this.creating = false
            return false
          }

          api.createAmazonFeed(this.moduleType, this.moduleIdentifier, this.account)
            .then(() => {
              notifier.success('Carga criada com sucesso.', 'Sucesso')
              this.onChange()
            })
            .catch(error => {
              if (error.response.status === 422) {
                notifier.error('Nenhum produto foi encontrado para criar uma carga.', 'Erro')
                return
              }

              notifier.error('Erro ao criar a carga.', 'Erro')
            })
            .then(() => (this.creating = false))
        } else {
          api.createFeed(this.moduleType, this.moduleIdentifier)
            .then(() => {
              notifier.success('Carga criada com sucesso.', 'Sucesso')
              this.onChange()
            })
            .catch(error => {
              if (error !== undefined && error.response !== undefined) {
                if (error.response.status === 422) {
                  notifier.error('Nenhum produto foi encontrado para criar uma carga.', 'Erro')
                  return
                } else {
                  notifier.error('Erro ao criar a carga.', 'Erro')
                  return
                }
              }
            })
            .then(() => (this.creating = false))
        }
      }
    },
    computed: {
      ...mapFields({
        totalFeeds: 'feed.total',
        feeds: 'feed.feeds',
        fetching: 'feed.fetching'
      }),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      module () {
        return this.getDefinitionModuleByIdentifierAndType(this.moduleType, this.moduleIdentifier)
      }
    },
    watch: {
      createdDate (value) {
        if (value[0]) {
          this.options.createdStart = value[0]
        }

        if (value[1]) {
          this.options.createdEnd = value[1]
        }
      }
    },
    components: {
      List,
      FormGroup,
      Panel,
      FeedCard,
      CreateModal
    }
  }
</script>



// WEBPACK FOOTER //
// Shared.vue?3b46c7c0